import { render, staticRenderFns } from "./NestedContent.vue?vue&type=template&id=5bb4412c&scoped=true"
import script from "./NestedContent.vue?vue&type=script&lang=js"
export * from "./NestedContent.vue?vue&type=script&lang=js"
import style0 from "./NestedContent.vue?vue&type=style&index=0&id=5bb4412c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb4412c",
  null
  
)

export default component.exports